module.exports = __webpack_public_path__ + "img/combined-logo.ab3a937a.svg";